// extracted by mini-css-extract-plugin
export var secondSection = "secondSection-module--secondSection--3LsjX";
export var item = "secondSection-module--item--2kq2Z";
export var icon = "secondSection-module--icon--1edQy";
export var title = "secondSection-module--title--2jDCy";
export var description = "secondSection-module--description--3WZqG";